import {
  setLoginUser,
  setLoginFlag,
  setLoginUserType,
} from "../login/loginAction";
import { setGymAttributes, setGyms, setGym } from "../gym/gymAction";
import {
  setTrainerAttributes,
  setTrainers,
  setTrainer,
  setTrainerSearch,
} from "../trainer/trainerAction";
import { setLoginModal, setQuestionnaireModalOpen } from "../modal/modalAction";
import { api } from "../../../api/api";
import { history } from "../../../app/AppRouter";
import { setSocialMedia } from "../socialMedia/socialMediaAction";
import { setAccounts } from "../account/accountAction";
import { toastr } from "react-redux-toastr";
import { setClasses, setClassSearch, setClass } from "../class/classAction";
import { setTempMobileToken, setUserInfo, setWods } from "../user/userAction";
import {
  setNotifications,
  setUnreadNotificationCount,
} from "../notification/notificationAction";
import {
  setLanguage,
  setDirection,
} from "../languageDirection/languageDirectionAction";
import {
  subscribeToMember,
  getNotifications,
} from "../../../services/socketInstance";
import { setTerms, setPrivacyPolicy } from "../agreement/agreementActions";
import {
  setCards,
  setCheckoutResponse,
  setMobilePaymentStatus,
  setTempPackageId,
} from "../card/cardAction";
import i18n from "../../../i18n";
import axios from "axios";
export const loginApi = (value) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    await api("member/login", value, "postWithoutToken")
      .then((res) => {
        if (res.status === 400) {
          toastr.error(
            i18n.t("toast_login_title"),
            i18n.t(`${res.data.error}`)
          );
        } else {
          toastr.success(
            i18n.t("toast_login_title"),
            i18n.t("toast_success_login")
          );
          dispatch(setLoginUser(res.data.data));
          subscribeToMember(`${res.data.data.id}M`);
          dispatch(setLoginUserType(res.data.data.loginType));
          getNotifications();
          localStorage.setItem(
            "connectToFitWebsiteUser",
            JSON.stringify(res.data.data)
          );
          // console.log("api pswrd", res.data.data);
          dispatch(setLoginFlag(true));
          dispatch(setLoginModal(false));
          history.push("/userinfo");
        }
      })
      .catch((err) => {});
  };
};

export const registerApi = (value) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api("member/register", value, "post").catch((err) => {});
    if (res) {
      if (res.status !== 201) {
        toastr.error(i18n.t("toast_register_title"), res.data.error);
      } else {
        toastr.success(
          i18n.t("toast_register_title"),
          i18n.t("toast_success_register")
        );
        dispatch(setLoginUser(res.data.data));
        subscribeToMember(`${res.data.data.id}M`);
        dispatch(setLoginUserType(res.data.data.loginType));
        getNotifications();
        localStorage.setItem(
          "connectToFitWebsiteUser",
          JSON.stringify(res.data.data)
        );
        dispatch(setLoginFlag(true));
        dispatch(setLoginModal(false));
        history.push("/userinfo");
      }
    }
  };
};

export const logoutApi = (id) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api(`member/logout/${id}`, {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        toastr.error(i18n.t("toast_logout_title"), res.data.error);
      } else {
        toastr.success(
          i18n.t("toast_logout_title"),
          i18n.t("toast_success_logout")
        );
        dispatch(setLoginFlag(false));
        dispatch(setLoginUserType(""));
        dispatch(setLoginUser());
        localStorage.removeItem("connectToFitWebsiteUser");
        dispatch(setUserInfo({}));
        history.push("/");
      }
    }
  };
};

export const forgotPasswordApi = (email) => {
  // console.log(email);
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api(
      `member/forgotPassword`,
      { email: email },
      "patch"
    ).catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        toastr.error(i18n.t("toast_forgot_password_title"), res.data.error);
        return false;
      } else {
        // toastr.success("Forgot Password", "New password sent successfully");
        // history.push("/");
        toastr.success(
          i18n.t("toast_forgot_password_title"),
          i18n.t("toast_success_forgot_password")
        );
        // history.push("/");
        return true;
      }
    }
  };
};

export const resetPasswordApi = (data) => {
  // console.log(email);
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api(`member/resetPassword`, data, "patch").catch(
      (err) => {}
    );
    if (res) {
      if (res.status !== 200) {
        toastr.error(i18n.t("toast_forgot_password_title"), res.data.error);
      } else {
        toastr.success(
          i18n.t("toast_forgot_password_title"),
          i18n.t("toast_password_send_success")
        );
        history.push("/customer");
      }
    }
  };
};

export const letsConnectApi = async (value) => {
  // console.log("letsConnectApi", value);
  // dispatch(setloader(true));
  await api("inquiry", value, "post")
    .then((res) => {
      if (res.status === 400) {
        // toastr.error(res.data.error);
        toastr.error("Enter Proper Data");
      } else {
        toastr.success(i18n.t("response_thank"));
      }
    })
    .catch((err) => {});
};

export const submitQuestionnaire = (data) => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api("potentialGym", data, "post").catch((err) => {});
    try{

      if (res) {
        if (res.status !== 201) {
          // toastr.error("User Register",res.data.error);
        } else {
          toastr.success("Thanks! Hang tight, we'll get in touch very soon.");
          dispatch(setQuestionnaireModalOpen(false))
        }
      }
    }catch(e){
      toastr.error("Something went wrong");
    };
  }
};
export const gymsAttributesApi = () => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api("gymAttribute", {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        // toastr.error("User Register",res.data.error);
        // console.log("error");
      } else {
        // toastr.success('User Register', 'User registered successfully');
        dispatch(setGymAttributes(res.data.data));
      }
    }
  };
};

export const getGyms = (
  country,
  page,
  limit,
  search = "",
  sort = "u.createdAt desc"
) => {
  return async (dispatch, store) => {
    let url = search
      ? `web/gym?page=${page}&limit=${limit}&name=${search}&sort=${sort}&country=${country}`
      : `web/gym?page=${page}&limit=${limit}&sort=${sort}&country=${country}`;
    let res = await api(url, {}, "get").catch((err) => {});

    if (res.status === 400) {
      toastr.error("some error occured");
    } else {
      dispatch(setGyms(res.data.data));
    }
  };
};

export const gymsApi = (
  country,
  limit = 10,
  page = 1,
  search,
  sort = "u.name asc",
  attributes
) => {
  return async (dispatch, store) => {
    let url = search
      ? `web/gym?page=${page}&limit=${limit}&sort=${sort}&search=${search}&country=${country}`
      : `web/gym?page=${page}&limit=${limit}&sort=${sort}&country=${country}`;
    if (attributes) url = url + `&attr=${attributes}`;
    // dispatch(setloader(true));
    let res = await api(url, {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Gyms", "Some error Occured. Try again");
        // console.log("error");
      } else {
        // toastr.success('User Register', 'User registered successfully');
        dispatch(setGyms(res.data.data, res.data.totalCount));
      }
    }
  };
};

export const resetGyms = () => {
  return async (dispatch, store) => {
    dispatch(setGyms([], 0));
  };
};

export const trainersAttributesApi = () => {
  return async (dispatch, store) => {
    // dispatch(setloader(true));
    let res = await api("trainerAttribute", {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        // toastr.error("User Register",res.data.error);
        // console.log("error");
      } else {
        // toastr.success('User Register', 'User registered successfully');
        dispatch(setTrainerAttributes(res.data.data));
      }
    }
  };
};

export const trainersApi = (
  country,
  limit = 10,
  page = 1,
  search,
  sort = "u.name asc",
  attributes
) => {
  return async (dispatch, store) => {
    let url = search
      ? `web/trainer?page=${page}&limit=${limit}&sort=${sort}&search=${search}&country=${country}`
      : `web/trainer?page=${page}&limit=${limit}&sort=${sort}&country=${country}`;
    if (attributes) url = url + `&attr=${attributes}`;
    // dispatch(setloader(true));
    let res = await api(url, {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Trainers", "Some error Occured. Try again");
        // console.log("error");
      } else {
        // toastr.success('User Register', 'User registered successfully');
        dispatch(setTrainers(res.data.data, res.data.totalCount));
      }
    }
  };
};

export const resetTrainers = () => {
  return async (dispatch, store) => {
    dispatch(setTrainers([], 0));
  };
};

export const classApi = (
  page = 1,
  limit = 10,
  search_class = "",
  search_trainer = "",
  attr = "2,3,4"
) => {
  return async (dispatch, store) => {
    // if(attributes)
    // url = url + `&attr=${attributes}`;
    // dispatch(setloader(true));
    let res = await api(
      `web/class?page=${page}&limit=${limit}&search_class=${search_class}&search_trainer=${search_trainer}&attr=${attr}`,
      {},
      "get"
    ).catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        toastr.error("Classes", "Some error Occured. Try again");
        // console.log("error");
      } else {
        if (`&search_class=${search_class}`) {
          dispatch(setClasses(res.data.data, res.data.totalCount));
        } else {
          dispatch(setTrainers(res.data.data, res.data.totalCount));
          history.push("/personaltrainer");
        }
      }
    }
  };
};

export const resetClasses = () => {
  return async (dispatch, store) => {
    dispatch(setClasses([], 0));
  };
};

export const setHomeClassSearch = (value) => {
  return async (dispatch, store) => {
    dispatch(setClassSearch(value));
  };
};

export const setHomeTrainerSearch = (value) => {
  return async (dispatch, store) => {
    dispatch(setTrainerSearch(value));
  };
};

export const getSocialMedia = (id) => {
  return async (dispatch, store) => {
    let res = await api(`web/socialMedia`, {}, "get").catch((err) => {});

    if (res) {
      if (res.status === 400) {
        toastr.error("some error occured");
      } else {
        dispatch(setSocialMedia(res.data.data.socialMedia));
        console.log(res.data.data.socialMedia.facebook);
      }
    }
  };
};
export const getAccount = (id) => {
  // debugger
  return async (dispatch, store) => {
    let res = await api(`web/member`, {}, "get").catch((err) => {});

    if (res) {
      if (res.status === 400) {
        // console.log("some error occured");
      } else {
        dispatch(setAccounts(res.data.data));
      }
    }
  };
};

export const editAccount = (id, value) => {
  // debugger
  return async (dispatch, store) => {
    let res = await api(`web/member`, value, "patch").catch((err) => {});

    if (res) {
      if (res.status === 400) {
        toastr.error(i18n.t("toast_account_update_title"), res.data.error);
      } else {
        // dispatch(
        let token = store().login.loginUser.token;
        let responseData = res.data.data;
        responseData.token = token;
        dispatch(setLoginUser(responseData));
        localStorage.setItem(
          "connectToFitWebsiteUser",
          JSON.stringify(responseData)
        );
        toastr.success(
          i18n.t("toast_account_update_title"),
          i18n.t("toast_success_account_update")
        );
        history.push("/accountinfo");
      }
    }
    // console.log("data in api", value);
  };
};
// export const editAccount = (id, value) => {
//   // debugger
//   return async (dispatch, store) => {
//   let res= await api(`web/member`, value, 'patch').catch((err) => {});
//         if (res.status === 400) {
//           toastr.error('some error occured');
//         } else {
//           if (
//             res.data.data.id === JSON.parse(localStorage.getItem('connectToFitWebsiteUser')).id
//           ) {
//             res.data.data.token = JSON.parse(
//               localStorage.getItem('connectToFitWebsiteUser')
//             ).token;
//             dispatch(setLoginUser(res.data.data));

//             localStorage.setItem('connectToFitWebsiteUser', JSON.stringify(res.data.data));
//             dispatch(setLoginFlag(true));
//             // dispatch(
//             //   setMessageData({
//             //     type: 'success',
//             //     message: 'User updated successfully',
//             //   })
//             // );
//           //   setTimeout(() => {
//           //     dispatch(setMessageData({}));
//           //   }, 5000);
//          }

//           toastr.success('Updated successfully');
//         }

//   };
// };
// export const checkPassword = (password) => {
//   //console.log("Password", password)
//   return async (dispatch, store) => {
//     let res = await api(`checkPassword`, password, 'patch').catch((err) => {});
//     if (!res.data.data) {
//       toastr.error('Invalid Password');
//       return false;
//     } else {
//       return true;
//     }
//   };
// };
export const checkPassword = (password) => {
  //console.log("Password", password)
  return async (dispatch, store) => {
    let res = await api(`checkPassword`, password, "patch").catch((err) => {});
    if (res) {
      if (!res.data.data) {
        toastr.error("Invalid Password");
        return false;
      } else {
        return true;
      }
    }
  };
};

export const sendForgotEmail = (email) => {
  //console.log("Password", password)
  return async (dispatch, store) => {
    let res = await api(
      `member/forgotPassword`,
      { email: email },
      "patch"
    ).catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        toastr.error(i18n.t("toast_forgot_password_title"), res.data.error);
        return false;
      } else {
        toastr.success(
          i18n.t("toast_forgot_password_title"),
          i18n.t("toast_success_forgot_password")
        );
        return true;
      }
    }
  };
};

export const resetPassword = (data, flag) => {
  //console.log("Password", password)
  return async (dispatch, store) => {
    let res = await api(`member/resetPassword`, data, "patch").catch(
      (err) => {}
    );
    if (res) {
      if (res.status !== 200) {
        toastr.error(i18n.t("toast_password_change_title"), res.data.error);
      } else {
        toastr.success(
          i18n.t("toast_password_change_title"),
          i18n.t("toast_password_change_success")
        );

        if (flag) history.push("/accountinfo");
      }
    }
  };
};
export const changePassword = (value) => {
  let id = JSON.parse(localStorage.getItem("connectToFitWebsiteUser")).id;
  let data = {
    newpassword: value.newPassword,
    confirmpassword: value.confirmPassword,
  };
  return async (dispatch, store) => {
    await api(`member/changePassword/${id}`, data, "patch")
      .then((res) => {
        if (res.status === 400) {
          toastr.error("some error occured");
        } else {
          //console.log(res.data.data);
          // dispatch(setWodsData(res.data.data));
          if (value.newPassword == value.confirmPassword) {
            toastr.success("Password Updated Successfully");
            history.push("/accountinfo");
          } else {
            toastr.error("some error occured");
          }
          // JSON.parse(localStorage.getItem("connectToFitWebsiteUser")) &&
          // JSON.parse(localStorage.getItem("connectToFitWebsiteUser")).role === "TRAINER"
          // ? history.push('/trainer-panel/trainerinfo')
          // : history.push('/gym-panel/gyminfo');
        }
      })
      .catch((err) => {});
  };
};

export const gymApi = (id) => {
  return async (dispatch, store) => {
    let res = await api(`web/gym/${id}`, {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Gyms",'Some error Occured. Try again');
        // console.log("error");
      } else {
        // toastr.success('User Register', 'User registered successfully');
        dispatch(setGym(res.data.data));
      }
    }
  };
};

export const userInfoApi = () => {
  return async (dispatch, store) => {
    let res = await api(`web/member`, {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Gyms",'Some error Occured. Try again');
        // console.log("error");
        history.push("/");
      } else {
        // toastr.success('User Register', 'User registered successfully');
        dispatch(setUserInfo(res.data.data));
      }
    }
  };
};

export const trainerApi = (id) => {
  return async (dispatch, store) => {
    let res = await api(`web/trainer/${id}`, {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Gyms",'Some error Occured. Try again');
        // console.log("error");
      } else {
        // toastr.success('User Register', 'User registered successfully');
        dispatch(setTrainer(res.data.data));
      }
    }
  };
};

export const notificationApi = () => {
  return async (dispatch, store) => {
    let res = await api(`web/notifications`, {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Gyms",'Some error Occured. Try again');
        // console.log("error");
      } else {
        // toastr.success('User Register', 'User registered successfully');
        dispatch(setNotifications(res.data.data));
      }
    }
  };
};

export const unreadNotificationCountApi = () => {
  return async (dispatch, store) => {
    let res = await api(`web/notifications/unread`, {}, "get").catch(
      (err) => {}
    );
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Gyms",'Some error Occured. Try again');
        // console.log("error");
      } else {
        // toastr.success('User Register', 'User registered successfully');
        dispatch(setUnreadNotificationCount(res.data.data));
      }
    }
  };
};

export const markReadApi = (id) => {
  return async (dispatch, store) => {
    let res = await api(`web/notifications/toggle/${id}`, {}, "get").catch(
      (err) => {}
    );
    if (res && res.status !== 200) {
      // toastr.error("Gyms",'Some error Occured. Try again');
      // console.log("error");
    }
  };
};

export const setLanguageType = (value) => {
  return async (dispatch, store) => {
    dispatch(setLanguage(value));
    localStorage.setItem("language", value);
  };
};

export const setDirectionType = (value) => {
  return async (dispatch, store) => {
    dispatch(setDirection(value));
  };
};

export const setLoginModalState = (value) => {
  return async (dispatch, store) => {
    dispatch(setLoginModal(value));
  };
};

export const checkClassAvailability = (id) => {
  return async (dispatch, store) => {
    let res = await api(`class/${id}/available`, {}, "get").catch((err) => {});
    if (res) {
      if (res.status === 200) return true;
    } else {
      return false;
    }
  };
};

export const bookClassApi = (id) => {
  return async (dispatch, store) => {
    let res = await api(`class/${id}/book`, {}, "get").catch((err) => {});
    if (res) {
      return res;
    }
  };
};

export const bookPackageApi = (id) => {
  return async (dispatch, store) => {
    let res = await api(`package/${id}/purchase`, {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        toastr.error(i18n.t(res.data.error));
        // console.log("error");
        return false;
      } else {
        return res.data.data;
      }
    }
  };
};
export const bookPackageFromMobile = (token, packageId) => {
  return async (dispatch, store) => {
    let mainUrl = process.env.REACT_APP_SERVER_URL;
    axios({
      data: {},
      method: "get",
      headers: {
        "Content-Type": "application/json",
        "x-auth": `${token}`,
      },
      url: `${mainUrl}package/${packageId}/purchase`,
    })
      .then((res) => {
        dispatch(setTempMobileToken(token));
        dispatch(setTempPackageId(packageId));
        dispatch(setCheckoutResponse(res.data.data));
      })
      .catch((err) => console.log(err.response));
  };
};

export const checkCheckoutStatusApi = (id) => {
  return async (dispatch, store) => {
    let res = await api(`pay/status`, { checkoutId: id }, "post").catch(
      (err) => {}
    );
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Gyms",'Some error Occured. Try again');
        // console.log("error");
        toastr.error(i18n.t("payment"), `${i18n.t("payment_failed")}`);
        return false;
        // history.push("/userinfo");
      } else {
        toastr.success(i18n.t("payment"), i18n.t("payment_success"));
        return true;

        // history.push("/userinfo");
      }
    }
  };
};
export const mobileCheckCheckoutStatusApi = (checkoutId, token) => {
  return async (dispatch, store) => {
    let mainUrl = process.env.REACT_APP_SERVER_URL;
    axios({
      data: { checkoutId: checkoutId },
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-auth": `${token}`,
      },
      url: `${mainUrl}pay/status`,
    })
      .then((res) => {
        // history.push(`${mainUrl}mobile-payment-success`);
        dispatch(setMobilePaymentStatus(res.data.data));
        toastr.success("Success");
      })
      .catch((err) => {
        dispatch(setMobilePaymentStatus(false));
        console.log("error");
        toastr.error(i18n.t("payment"), `${i18n.t("payment_failed")}`);
        return false;
      });
  };
  // if (res) {
  //   if (res.status !== 200) {
  // toastr.error("Gyms",'Some error Occured. Try again');
  // console.log("error");
  // toastr.error(i18n.t("payment"), `${i18n.t("payment_failed")}`);
  // return false;
  // history.push("/userinfo");
  // } else {
  //   toastr.success(i18n.t("payment"), i18n.t("payment_success"));
  //   return true;

  // history.push("/userinfo");
  //   }
  // }
  // };
};

export const userCardsApi = () => {
  return async (dispatch, store) => {
    let res = await api(`card`, {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Gyms",'Some error Occured. Try again');
        // console.log("error");
      } else {
        // toastr.success('User Register', 'User registered successfully');
        dispatch(setCards(res.data.data));
      }
    }
  };
};

export const deleteUserCardsApi = (rid) => {
  return async (dispatch, store) => {
    let res = await api(`card/${rid}`, {}, "delete").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        toastr.error(
          i18n.t("toast_user_card_title"),
          i18n.t("try_again_statement")
        );
        // console.log("error");
      } else {
        toastr.success(
          i18n.t("toast_user_card_title"),
          i18n.t("toast_card_delete_success")
        );
      }
    }
  };
};

export const addCardApi = () => {
  return async (dispatch, store) => {
    let res = await api(`card/checkout`, {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Gyms",'Some error Occured. Try again');
        // console.log("error");
        return false;
      } else {
        return res.data.data;
      }
    }
  };
};

export const checkCardCheckoutStatusApi = (id) => {
  return async (dispatch, store) => {
    let res = await api(`card/status`, { checkoutId: id }, "post").catch(
      (err) => {}
    );
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Gyms",'Some error Occured. Try again');
        // console.log("error");
        toastr.error(
          i18n.t("toast_user_card_title"),
          i18n.t("try_again_statement")
        );
        return false;
        // history.push("/userinfo");
      } else {
        toastr.success(
          i18n.t("toast_user_card_title"),
          i18n.t("toast_card_add_success")
        );
        return true;

        // history.push("/userinfo");
      }
    }
  };
};

export const getClassApi = (id) => {
  return async (dispatch, store) => {
    let res = await api(`web/class/${id}`, {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Gyms",'Some error Occured. Try again');
        // console.log("error");
        history.goBack();
      } else {
        dispatch(setClass(res.data.data));
      }
    }
  };
};

export const declineClassBooking = (id) => {
  return async (dispatch, store) => {
    let res = await api(`class/${id}/decline`, {}, "patch").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Gyms",'Some error Occured. Try again');
        // console.log("error");
      } else {
        toastr.success(i18n.t("book-class"), i18n.t("Offer Declined"));
        notificationApi();
        unreadNotificationCountApi();
      }
    }
  };
};

export const privacyPolicyApi = () => {
  //console.log("Password", password)
  return async (dispatch, store) => {
    let res = await api(`agreement?type=PP`, {}, "get").catch((err) => {});
    if (res && res.status !== 200) {
      // console.log('Error : Something went wrong. Try Again');
    } else {
      dispatch(setPrivacyPolicy(res.data.data));
    }
  };
};

export const termsApi = (type) => {
  //console.log("Password", password)
  return async (dispatch, store) => {
    let url=`agreement`
    if(type){
      url=`agreement?type=${type}`
    }else{
      url=`agreement?type=TC`
    }
    let res = await api(url, {}, "get").catch((err) => {});
    if (res && res.status !== 200) {
      // console.log('Error : Something went wrong. Try Again');
    } else {
      dispatch(setTerms(res.data.data));
    }
  };
};

export const wodApi = () => {
  return async (dispatch, store) => {
    let res = await api(`web/wod`, {}, "get").catch((err) => {});
    if (res) {
      if (res.status !== 200) {
        // toastr.error("Gyms",'Some error Occured. Try again');
        console.log("error");
      } else {
        // toastr.success('User Register', 'User registered successfully');
        dispatch(setWods(res.data.data));
      }
    }
  };
};

export const addReviewApi = (data) => {
  return async (dispatch, store) => {
    let res = await api(`review`, data, "post").catch((err) => {});
    if (res) {
      if (res.status !== 201) {
        toastr.error(i18n.t("review"), i18n.t("try_again_statement"));
        // console.log("error");
      } else {
        toastr.success(i18n.t("review"), i18n.t("review_add_success"));
        if (data.gym) {
          await dispatch(gymApi(data.gym));
        } else await dispatch(trainerApi(data.trainer));
        // dispatch(setWods(res.data.data));
      }
    }
  };
};
